import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import CryptoJS from "crypto-js";
import { Row, Col, Form, Label, Input, FormFeedback, Button } from "reactstrap";
// import images
import lightlogo from "../../assets/images/cashinvoice-white-logo.svg";
import verificationImg from "../../assets/images/5024147-Photoroom.png";
import colorlogo from "../../assets/images/ci_logo.png";
import "assets/scss/custom/pages/_signup.scss";
import ToastDialog from "components/Common/ToastDialog";
import { callLoginUser, sendLoginOtp } from "http/auth/login";
import "./ToggleSwitch.scss";
import API_SERVICES from "constants/app.constants";
import { callResendOTP } from "http/auth/signup";
import MicrosoftLogo from "../../assets/images/Microsoft_logo.svg";

const CustomerSignIn = () => {
  const navigate = useNavigate();
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [visible, setVisible] = useState(false);
  document.title = "Login | FundLync";
  const [activeTab, setActiveTab] = useState("email");

  const handleToggle = (tab) => {
    setActiveTab(tab);
  };

  const validationMobile = useFormik({
    enableReinitialize: true,
    initialValues: {
      phone: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .test('emailOrPhone', 'Invalid email or mobile number', function (value) {
          const { path, createError } = this;
          const isValidEmail = Yup.string().email().isValidSync(value);
          const isValidPhone = Yup.string()
            .matches(API_SERVICES.MOBILE_PATTERN, { excludeEmptyString: true })
            .isValidSync(value);

          if (!isValidEmail && !isValidPhone) {
            return createError({ path, message: 'Enter a valid email or 10-digit mobile number' });
          }

          return true;
        })
        .required('Email or mobile number is required'),
    }),
    onSubmit: (values) => {
      submitMobileOTP(values.phone);
    },
  });

  const validationEmail = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Must be a valid Email").max(255).required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      submitUserLogin(values);
    },
  });

  const submitUserLogin = (values) => {
    const passphrase = process.env.REACT_APP_KEY;
    const encrypted = CryptoJS.AES.encrypt(
      values.password,
      passphrase
    ).toString();
    const postParams = {
      email: values.email,
      password: encrypted,
    };
    callLoginUser(postParams)
      .then((result) => {
        if (result.code == 200 && result.status) {

          const { data, tokens, permissions } = result;
          if (data.entityIsVerify == 1) {
            data.EntityAssignedFlag = data.EntityAssignedFlag == 1

            const passphrase = process.env.REACT_APP_KEY;
            const encryptedUser = CryptoJS.AES.encrypt(
              JSON.stringify(data),
              passphrase
            ).toString();
            localStorage.setItem("user", encryptedUser)

            localStorage.setItem("tokens", JSON.stringify(tokens));
            localStorage.setItem("permissions", JSON.stringify(permissions));
            const encryptedId = btoa(result.data.entityId.toString());
            
            if (data.roleName==="fundLync_cutomer") {
              
              localStorage.setItem("encryptedId", JSON.stringify(encryptedId));
              navigate(
                `/customer/entity-dashboard?id=${encodeURIComponent(
                  encryptedId
                )}`
              );
            }else if (data.roleName == "financier_admin") {
              navigate(`/financier_admin/dashboard`);
            } else if (data.roleName == "financier_operations") {
              navigate(`/financier_operations/dashboard`);
            }
             else {
              navigate(`/${data.roleName}/dashboard`);
            }
          } else {
            validationEmail.setSubmitting(true);
            const postParams = {
              entityId: String(data.entityId),
              email: data.email,
            };
            callResendOTP(postParams)
              .then((result) => {
                if (result.status) {
                  navigate({
                    pathname: "/customer/register-otp-verify",
                    search: `?email=${data.email}&entity=${data.entityId}`,
                  });
                  validationEmail.setSubmitting(false);
                } else {
                  const { message } = result;
                  setToastInfo({ message: message, showToast: true, role: "error" });
                }
              })
              .catch((e) => { })
              .finally((f) => { });
          }
        } else {
          const { message } = result;
          validationEmail.setSubmitting(false);
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((e) => {
        validationEmail.setSubmitting(false);
      })
      .finally((f) => {
      });
  };

  const submitMobileOTP = (phone) => {
    sendLoginOtp({ phone: phone })
      .then((result) => {
        if (result.status) {
          setToastInfo({ message: result.message, showToast: true, role: "success" });
          setTimeout(() => {
            navigate({
              pathname: "/mobile-otp-verify",
              search: `?mobile=${phone}&id=${result.data.uuid}`,
            });
          }, 500)
        } else {
          setToastInfo({ message: result.message, showToast: true, role: "error" });
        }
      })
      .catch((e) => {
        validationMobile.setSubmitting(false);
      })
      .finally((f) => {
        validationMobile.setSubmitting(false);
      });
  }

  return (
    <React.Fragment>
      <div className="account-pages account-pages-bg bg-color login-page">
        <Row className="justify-content-center m-auto h-100vh scrollable-height" style={{width:'90%'}}>
          <Col  md={6} xl={8} lg={7} className="d-none d-md-block">
            <div className="left-section h-100">
              <div className="d-flex w-100 justify-content-center">
                <img src={lightlogo} alt="" className="img-fluid ci-logo"  style={{ width: '200px' }} />
              </div>

              <div className="d-flex justify-content-center w-100  h-100 align-items-center">
                <img
                  src={verificationImg}
                  alt=""
                  className="img-fluid verification-img"
                />
              </div>
            </div>
          </Col>
          <Col
            md={6}
            lg={5}
            xl={4}
            className="form-layout-section m-auto d-flex justify-content-center"
          >
              <div className="d-flex w-100  justify-content-center d-block d-md-none">
                <img src={colorlogo} alt="" className="img-fluid ci-logo" />
              </div>

            <div>
              <div className="d-flex flex-column align-items-center">
                <h3 className="mt-3 mb-3 header-reg">Login</h3>
              </div>
              <div
                className="d-flex"
                style={{ justifyContent: "center", marginTop: "1rem" }}
              >
                <div className="toggle-switch-container">
                  <div className="toggle-switch">
                    <label
                      className={`switch-label ${activeTab === "mobile" ? "active" : ""
                        }`}
                      onClick={() => handleToggle("mobile")}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleToggle("mobile");
                        }
                      }}
                    >
                      OTP Verification
                    </label>
                    <label
                      className={`switch-label ${activeTab === "email" ? "active" : ""
                        }`}
                      onClick={() => handleToggle("email")}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleToggle("email");
                        }
                      }}
                    >
                      Email
                    </label>
                    <div
                      className={`slider ${activeTab === "email" ? "slide-right" : ""
                        }`}
                    ></div>
                  </div>

                 
                </div>
              </div>
              <div className="content-container">
                {activeTab === "mobile" && (
                  <div className="toogle-content">
                    <Form
                      className="form-horizontal mt-2"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validationMobile.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="form-floating mb-3">
                        <Input
                          name="phone"
                          placeholder="Enter Valid Mobile Number"
                          type="text"
                          className="form-control"
                          id="validationCustom04"
                          onChange={validationMobile.handleChange}
                          onBlur={validationMobile.handleBlur}
                          value={validationMobile.values.phone || ""}
                          invalid={
                            !!(
                              validationMobile.touched.phone &&
                              validationMobile.errors.phone
                            )
                          }
                          disabled={validationMobile.isSubmitting}
                        />
                        <Label htmlFor="validationCustom04">
                          Mobile Number / Email Id
                        </Label>
                        {validationMobile.touched.phone &&
                          validationMobile.errors.phone ? (
                          <FormFeedback type="invalid">
                            {validationMobile.errors.phone}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="w-100 mt-3 d-flex justify-content-center">
                        <Button color="primary" type="submit">
                          {validationMobile.isSubmitting ? (
                            <span
                              className="spinner-border spinner-border-sm ms-2 me-2"
                              aria-hidden="true"
                            ></span>
                          ) : null}
                          {!validationMobile.isSubmitting ? (
                            <span>Send OTP</span>
                          ) : (
                            <span>Authenticating</span>
                          )}
                        </Button>
                      </div>
                    </Form>

                    <div className="mt-2 text-center">
                      <p>
                        New User?{" "}
                        <Link
                          to="/customer/register"
                          className="fw-medium text-primary"
                        >
                          {" "}
                          Signup
                        </Link>{" "}
                      </p>
                      <p>
                        Have a partner
                        <Link
                          to="/inquiry"
                          className="fw-medium text-primary"
                        >
                          {" "}
                          Inquiry?
                        </Link>{" "}
                      </p>
                      {/* <p>
                        <img src={MicrosoftLogo} alt="Microsoft logo" className="img-fluid" style={{ width: '20px', height: '20px' }} />
                        <Link to="/internal-login" className="fw-medium text-primary">
                          {" "}
                          Login
                        </Link>{" "}with Microsoft
                      </p> */}
                    </div>
                  </div>
                )}

                {activeTab === "email" && (
                  <div className="toogle-content">
                    <Form
                      className="form-horizontal mt-2"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validationEmail.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="form-floating mb-3">
                        <Input
                          name="email"
                          placeholder="Enter Valid Email"
                          type="email"
                          className="form-control"
                          id="validationCustom04"
                          onChange={validationEmail.handleChange}
                          onBlur={validationEmail.handleBlur}
                          value={validationEmail.values.email || ""}
                          invalid={
                            !!(
                              validationEmail.touched.email &&
                              validationEmail.errors.email
                            )
                          }
                          disabled={validationEmail.isSubmitting}
                        />

                        <Label htmlFor="validationCustom04">Email</Label>
                        {validationEmail.touched.email &&
                          validationEmail.errors.email ? (
                          <FormFeedback type="invalid">
                            {validationEmail.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="form-floating mb-3">
                        <div className="password-info">
                          <div className="form-floating">
                            <Input
                              name="password"
                              type={visible ? "text" : "password"}
                              placeholder="Password"
                              id="validationPassword"
                              onChange={validationEmail.handleChange}
                              onBlur={validationEmail.handleBlur}
                              value={validationEmail.values.password || ""}
                              invalid={
                                !!(
                                  validationEmail.touched.password &&
                                  validationEmail.errors.password
                                )
                              }
                              disabled={validationEmail.isSubmitting}
                            />
                            <Label htmlFor="validationPassword">
                              Password
                            </Label>
                            {validationEmail.touched.password &&
                              validationEmail.errors.password ? (
                              <FormFeedback type="invalid">
                                {validationEmail.errors.password}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div
                            onClick={() => setVisible(!visible)}
                            className="password-i"
                            id="passwordInfo"
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === "Space") {
                                setVisible(!visible);
                              }
                            }}
                          >
                            {visible ? (
                              <i className="mdi mdi-eye"></i>
                            ) : (
                              <i className="mdi mdi-eye-off"></i>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="mt-2 text-start">
                        <p>
                          Forgot Password?{" "}
                          <Link
                            to="/forget-password"
                            className="fw-medium text-primary"
                          >
                            {" "}
                            Reset
                          </Link>{" "}
                        </p>
                      </div>

                      <div className="w-100 mt-3 d-flex justify-content-center">
                        <Button color="primary" type="submit">
                          {validationEmail.isSubmitting && (
                            <span
                              className="spinner-border spinner-border-sm ms-2 me-2"
                              aria-hidden="true"
                            ></span>
                          )}
                          {!validationEmail.isSubmitting && (
                            <span>Sign In</span>
                          )}
                          {validationEmail.isSubmitting && (
                            <span>Authenticating</span>
                          )}
                        </Button>
                      </div>
                    </Form>

                    <div className="mt-2 text-center">
                      <p>
                        New User?{" "}
                        <Link
                          to="/customer/register"
                          className="fw-medium text-primary"
                        >
                          {" "}
                          Signup
                        </Link>{" "}
                      </p>
                      <p>
                        Have a partner
                        <Link
                          to="/inquiry"
                          className="fw-medium text-primary"
                        >
                          {" "}
                          Inquiry?
                        </Link>{" "}
                      </p>
                      {/* <p>
                        <img src={MicrosoftLogo} alt="Microsoft logo" className="img-fluid" style={{ width: '20px', height: '20px' }} />
                        <Link to="/internal-login" className="fw-medium text-primary">
                          {" "}
                          Login
                        </Link>{" "}with Microsoft
                      </p> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default CustomerSignIn;
